import { LazyProvider, getCachedName, fetchProviderName } from 'app/components/shared/LazyProvider'

function buildCacheKey(sikkaOfficeId?: string, sikkaPracticeId?: string, providerId?: string) {
  if (!sikkaOfficeId || !sikkaPracticeId || !providerId) return ``
  return `sikka:${sikkaOfficeId}:${sikkaPracticeId}:${providerId}`
}

function parseSikkaName(data: Record<string, string>) {
  return data?.firstname && data?.lastname ? `${data.firstname} ${data.lastname}` : ``
}

/**
 * Sikka API returns { firstname, lastname } instead of { name },
 * so we pass a custom parser to compose the full name.
 */
export async function getName(sikkaOfficeId: string, sikkaPracticeId: string, providerId: string) {
  const cacheKey = buildCacheKey(sikkaOfficeId, sikkaPracticeId, providerId)
  if (!cacheKey) return ``
  const cached = getCachedName(cacheKey)
  if (cached != null) return cached
  return fetchProviderName(cacheKey, `/api/providers/${sikkaOfficeId}/${sikkaPracticeId}/${providerId}`, parseSikkaName)
}

export function LazySikkaProvider(props: {
  sikkaOfficeId?: string
  sikkaPracticeId?: string
  providerId?: string
  showIcon?: boolean
  showSpinner?: boolean
  hideWith?: boolean
}) {
  const cacheKey = buildCacheKey(props.sikkaOfficeId, props.sikkaPracticeId, props.providerId)

  return (
    <LazyProvider
      cacheKey={cacheKey}
      fetchName={() => getName(props.sikkaOfficeId!, props.sikkaPracticeId!, props.providerId!)}
      showIcon={props.showIcon}
      showSpinner={props.showSpinner}
      hideWith={props.hideWith}
    />
  )
}
